var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5067 100.25C78.1209 100.25 100.507 77.8641 100.507 50.2499C100.507 22.6356 78.1209 0.249878 50.5067 0.249878C22.8925 0.249878 0.506714 22.6356 0.506714 50.2499C0.506714 77.8641 22.8925 100.25 50.5067 100.25Z",
    fill: "url(#paint0_linear_17_280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3643 53.9092L40.3835 70.3251C40.3835 70.3251 41.1359 71.8641 41.9225 71.8641C42.709 71.8641 54.5421 59.5864 54.5421 59.5864L67.7432 34.2102L34.5695 49.5659L34.3643 53.9092Z",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2304 58.116L41.0676 70.0859C41.0676 70.0859 40.5888 73.8136 44.3166 70.0859C48.0444 66.3581 51.5669 63.5195 51.5669 63.5195L42.2304 58.116Z",
    fill: "#A9C6D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4669 54.4906L22.2576 50.5234C22.2576 50.5234 20.787 49.942 21.2658 48.6082C21.2658 48.3004 21.5736 48.0952 22.155 47.6849C24.8567 45.8039 72.1892 28.7724 72.1892 28.7724C72.8829 28.58 73.6158 28.58 74.3095 28.7724C74.5059 28.8302 74.6828 28.9403 74.8213 29.0909C74.9599 29.2415 75.0549 29.427 75.0962 29.6274C75.1424 29.9793 75.1424 30.3357 75.0962 30.6876C75.0962 30.9954 75.0962 31.3032 75.0962 31.7478C74.8226 36.3989 66.17 71.1117 66.17 71.1117C66.17 71.1117 65.657 73.1636 63.8102 73.232C63.3568 73.2437 62.9056 73.165 62.4828 73.0006C62.0601 72.8362 61.6743 72.5894 61.3478 72.2744C57.7227 69.1623 45.1714 60.7149 42.4012 58.8682C42.3356 58.8275 42.2799 58.7726 42.2385 58.7074C42.197 58.6423 42.1708 58.5686 42.1618 58.492C42.1123 58.3479 42.1123 58.1914 42.1618 58.0474C42.1618 58.0474 64.0154 38.6219 64.5968 36.6041C64.5968 36.4331 64.5968 36.3647 64.2548 36.4331C62.7843 36.9803 37.6474 52.849 34.8773 54.5932C34.7359 54.581 34.5973 54.5464 34.4669 54.4906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_280",
    x1: 50.5067,
    y1: 100.25,
    x2: 50.5067,
    y2: 0.249878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.a7ab2e0f3e6958a16d7860e5a2474269.svg";
export { ForwardRef as ReactComponent };